// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const NotificationInfoCircle: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#095d8b",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 18 19" width={width} height={height}>
            <path
                fill="currentColor"
                d="M9 1.375a7.875 7.875 0 1 1 0 15.75 7.875 7.875 0 0 1 0-15.75M9 18.25a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-1.687-5.625a.564.564 0 0 0-.563.563c0 .309.253.562.563.562h3.375a.564.564 0 0 0 .562-.562.564.564 0 0 0-.562-.563H9.563V8.688A.564.564 0 0 0 9 8.124H7.594a.564.564 0 0 0-.563.563c0 .309.253.562.563.562h.844v3.375zM9 6.719A.844.844 0 1 0 9 5.03a.844.844 0 0 0 0 1.69"
            />
        </svg>
    );
};

export default React.memo(NotificationInfoCircle);
